export default {
	riskAssessment: {
		zonesListAttributeKeys: [
			{
				title: 'Land & urban blocks',
				keys: ['zone_id', 'ua_l3', 'chng_type', 'chng_year_', 'mp_cnt'],
			},
			{
				title: 'Zonal statistics - exposure to annual subsidence rates',
				keys: [
					'defo_min',
					'defo_p25',
					'defo_median',
					'defo_mean',
					'defo_p75',
					'defo_max',
					'defo_std',
				],
			},
			{
				title: 'Zonal frequency - reliability classes',
				keys: ['rel_a', 'rel_b', 'rel_c', 'rel_d', 'rel_e'],
			},
			{
				title: 'Zonal frequency - exposure to hazard classes',
				keys: [
					'haz_0_10',
					'haz_10_20',
					'haz_20_30',
					'haz_30_40',
					'haz_40_50',
					'haz_50__',
				],
			},
			{
				title: 'Prevailing spatial pattern',
				keys: ['lmi_hh', 'lmi_hl', 'lmi_lh', 'lmi_ll'],
			},
		],
		roadsListAttributeKeys: [
			{
				title: 'Streets & roads',
				keys: ['gid', 'fclass', 'rd_len', 'cm_haz'],
			},
		],
		// popupAttributeKeys: ["km", "zone_id", "type", "p75", "p75_weight"],
	},
	interferometry: {
		fidColumnName: 'id',
		// popupAttributeKeys: ["id", "vel_avg", "coh_mod", "rel_cm", "orbit"],
		listAttributeKeys: [
			{
				keys: ['id'],
			},
			{
				title: 'Interferometric estimations',
				keys: ['vel_avg', 'vel_cum', 's0', 'h', 'h_ref', 'h_sd'],
			},
			{
				title: 'Interferometric reliability',
				keys: ['coh', 'cm_coh'],
			},
			{
				title: 'Deformation trend',
				keys: [
					't_start',
					't_stop',
					'y_start',
					'y_stop',
					'cl_warn',
					'cl_ue',
					'corr_ue',
				],
			},
			{
				title: 'Spatial pattern',
				keys: ['lmi_idx', 'lmi_zscore', 'lmi_pval', 'lmi_potype'],
			},
			{
				title: 'Metadata',
				keys: ['rel_track', 'orbit', 'inc_ang', 'az_ang', 'method'],
			},
		],
		tracks: {
			types: {
				keys: ['los'],
				activeKey: 'los',
			},
			orbits: {
				keys: ['ascending', 'descending'],
				activeKeys: ['descending'],
				lastInteractedTrackKey: null,
				trackByKey: {
					ascending: ['t26'],
					descending: ['t18'],
				},
			},
		},
	},
	layerOrder: {
		'interferometry-big': [
			'interferometry-zones-big',
			'interferometry-roads-big',
			'interferometry-points-big',
		],
		'interferometry-small': [
			'interferometry-zones-small',
			'interferometry-roads-small',
			'interferometry-points-small',
		],
		'risk-assessment-big': [
			'risk-assessment-zones-big',
			'risk-assessment-roads-big',
		],
		'risk-assessment-small': [
			'risk-assessment-zones-small',
			'risk-assessment-roads-small',
		],
	},
	layerStyles: {
		'risk-assessment-zones-big': {
			active: 'riskAssessmentZonesDeformationBig',
			available: [
				'riskAssessmentZonesDeformationBig',
				'riskAssessmentZonesLandUseBig',
				'riskAssessmentZonesChangeTypeBig',
				'riskAssessmentZonesChangeYearBig',
			],
		},
		'risk-assessment-roads-big': {
			active: null,
			available: [
				'riskAssessmentRoadsVelAvgBig',
				'riskAssessmentRoadsTypologyBig',
			],
		},
		'interferometry-points-big': {
			active: 'interferometryPointsVelAvgBig',
			available: [
				'interferometryPointsVelAvgBig',
				'interferometryPointsVelAvgAlarmBig',
				'interferometryPointsSpatialPatternTypeBig',
			],
		},
		'interferometry-zones-big': {
			active: 'interferometryZonesBig',
			available: [
				'interferometryZonesBig',
				'riskAssessmentZonesLandUseBig',
				'riskAssessmentZonesChangeTypeBig',
				'riskAssessmentZonesChangeYearBig',
			],
		},
		'interferometry-roads-big': {
			active: null,
			available: [
				'riskAssessmentRoadsVelAvgBig',
				'riskAssessmentRoadsTypologyBig',
			],
		},
	},
	bigSmallMapPairs: {
		maps: {
			'risk-assessment-big': 'risk-assessment-small',
			'interferometry-big': 'interferometry-small',
		},
		layers: {
			'risk-assessment-zones-big': 'risk-assessment-zones-small',
			'risk-assessment-roads-big': 'risk-assessment-roads-small',
			'interferometry-points-big': 'interferometry-points-small',
			'interferometry-zones-big': 'interferometry-zones-small',
			'interferometry-roads-big': 'interferometry-roads-small',
		},
		styles: {
			riskAssessmentZonesDeformationBig: 'riskAssessmentZonesDeformationBig',
			riskAssessmentZonesLandUseBig: 'riskAssessmentZonesLandUseSmall',
			riskAssessmentZonesChangeYearBig: 'riskAssessmentZonesChangeYearSmall',
			riskAssessmentZonesChangeTypeBig: 'riskAssessmentZonesChangeTypeSmall',
			riskAssessmentRoadsVelAvgBig: 'riskAssessmentRoadsVelAvgSmall',
			riskAssessmentRoadsTypologyBig: 'riskAssessmentRoadsTypologySmall',

			interferometryPointsVelAvgBig: 'interferometryPointsVelAvgSmall',
			interferometryPointsSpatialPatternTypeBig:
				'interferometryPointsSpatialPatternTypeSmall',
			interferometryPointsVelAvgAlarmBig:
				'interferometryPointsVelAvgAlarmSmall',
			interferometryZonesBig: 'interferometryZonesSmall',
		},
	},
	renderAsStylePairs: {
		interferometryPointsVelAvgBig: 'interferometryPointsVelAvgBigAsPoints',
		interferometryPointsSpatialPatternTypeBig:
			'interferometryPointsSpatialPatternTypeBigAsPoints',
		interferometryPointsVelAvgAlarmBig:
			'interferometryPointsVelAvgAlarmBigAsPoints',
	},
	wmsLayersGroups: [
		{
			name: 'World Bank',
			layers: ['urbanDevelopment'],
		},
		{
			name: 'DLR',
			attribution: 'Source: DLR/Google',
			layers: ['evolution'],
		},
		{
			name: "JRC's Global Surface Water",
			attribution: 'Source: EC JRC/Google',
			layers: [
				'occurrence',
				'change',
				'seasonality',
				'recurrence',
				'transitions',
			],
		},
	],
	activeViewKey: 'f0217d4c-60dd-4416-91f2-67f2e7f1426c',
};
